import api from 'api/axiosInstance';
import type { CountryType } from 'types/countries';

export const getUserCountries = (): Promise<CountryType[]> =>
  api.get('/v1/users/countries');
